import { defineStore } from "pinia";
import { ref } from "vue";

export const useUserInfoStore = defineStore("userInfo", () => {
  const email = ref("");
  const user_name = ref("");
  const user_id = ref("");
  const token = ref("");
  const role = ref(0);
  function init() {
    email.value = localStorage.getItem("email") || "";
    user_id.value = localStorage.getItem("user_id") || "";
    token.value = localStorage.getItem("token") || "";
    const storedRole = Number(localStorage.getItem("role") || 1);
    role.value = Number.isFinite(storedRole) && storedRole > 0 ? storedRole : 1;
  }

  function setUserId(value: string) {
    user_id.value = value;
    localStorage.setItem("user_id", value);
  }

  function setToken(value: string) {
    token.value = value;
    localStorage.setItem("token", value);
  }

  function setEmail(value: string) {
    email.value = value;
    localStorage.setItem("email", value);
  }
  function setUserName(value: string) {
    user_name.value = value;
    localStorage.setItem("user_name", value);
  }

  function setRole(value: number) {
    role.value = Number.isFinite(value) && value > 0 ? value : 1;
    localStorage.setItem("role", role.value + "");
  }

  init();

  return {
    email,
    user_id,
    token,
    role,
    user_name,
    init,
    setUserId,
    setToken,
    setEmail,
    setRole,
    setUserName,
  };
});
